module.exports = __webpack_public_path__ + "img/cross.ee331d11.svg";